var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3182 10.3154L13.7807 13.7779M10.3182 10.3154C9.86527 10.7781 9.32508 11.1457 8.7289 11.3982C8.13272 11.6508 7.49237 11.7826 6.84491 11.786C6.19746 11.7895 5.55574 11.6645 4.9569 11.4183C4.35806 11.1721 3.81399 10.8096 3.35616 10.3518C2.89833 9.89399 2.53584 9.34991 2.28966 8.75107C2.04348 8.15224 1.9185 7.51052 1.92194 6.86306C1.92539 6.21561 2.0572 5.57526 2.30975 4.97908C2.56229 4.38289 2.93056 3.84271 3.39324 3.38979C4.31487 2.48758 5.55521 1.98539 6.84491 1.99226C8.13461 1.99913 9.36954 2.5145 10.2815 3.42647C11.1935 4.33844 11.7089 5.57336 11.7157 6.86306C11.7226 8.15276 11.2204 9.39376 10.3182 10.3154Z",
    stroke: "black",
    strokeWidth: 1.30586,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search-black.cc38c8846b6d2e2bba0225ac8e24de36.svg";
export { ForwardRef as ReactComponent };